import React, { useEffect, useState } from "react";
import "./style.css";
import TeamContent from "./components/team";
import BillingContent from "./components/billing";
import ProfileContent from "./components/profile";
import CompanyContent from "./components/company";
import IntegrationsContent from "./components/integration";
import AgentManager from "./components/AgentManager";
import { useUserInfo } from "../../context/user";
import Balance from "./components/Balance";
import Files from "./components/Files";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate } from "react-router-dom";
import { tabToHash, hashToTab } from "./tabSlugs";
import ApiAccess from "./components/ApiAccess";
import Pricing from "./components/Pricing/Pricing";
import ResetContext from "./components/ResetContext";
import DataInterpreter from "./components/DataInterpreter";
import Webhooks from "./components/Webhooks";
import { useUsersContext } from "../../context/usersContext";
import Wallet from "./components/wallet";
import Guardrails from "./components/Guardrails";
import ScriptRenderer from "../../components/ScriptRenderer";

function Settings() {
  const checkIfGhlUser = useUserInfo()[9];
  // const agencyData = useUserInfo()[11];
  const [activeTab, setActiveTab] = useState("");
  const [limit, setLimit] = useState(false);
  const [pricingHeading, setPricingHeading] = useState("");
  const location = useLocation(); // Hook to get current location
  const navigate = useNavigate();
  // Switch configure tab via its URL hash (the resolver effect below sets
  // activeTab from the hash) — keeps each configure page at its own shareable URL.
  const selectTab = (tab) => navigate(`/app/settings${tabToHash(tab)}`);
  const userActiveLocation = useUserInfo()[4];
  const userInfo = useUserInfo()[0];
  const { products, agency: agencyData } = useUsersContext();

  const agentShow = useUserInfo()[18];
  const not_in_plan_and_saas_modere_billing = [
    "Knowledge Base",
    "Data Interpreter",
    "Integrations",
    "API Access",
    "Pricing",
    "Billing",
    "Profile",
    "Team",
    "Agents",
    "Reset Context",

  ];
  const activePlan = products?.find((item) => item?.activePlan === true)

  let sidebarMenus = [
    { title: "Integrations", content: <IntegrationsContent /> },
    { title: "API Access", content: <ApiAccess /> },
    { title: "Knowledge Base", content: <Files setActiveTab={selectTab} /> },
    {
      title: "Data Interpreter",
      content: <DataInterpreter setActiveTab={selectTab} />,
    },
    { title: "Webhooks", content: <Webhooks /> },
    // { title: "Company", content: <CompanyContent /> },
    { title: "Guardrails", content: <Guardrails /> },

    { title: "Team", content: <TeamContent setActiveTab={selectTab} setPricingHeading={setPricingHeading} /> },
    ...(Object.keys(activePlan?.rebilling || {}).length > 0 && activePlan?.rebilling?.ai_active === true ? [{ title: "Wallet", content: <Wallet /> }] : []),
    ...(userActiveLocation?.type !== 'free' ? [{ title: "Billing", content: <Balance setActiveTab={selectTab} /> }] : []),
    // { title: "Agents", content: <AgentManager /> },
    { title: "Profile", content: <ProfileContent /> },
    ...(userActiveLocation?.type !== 'free' && (activePlan?.isenable_account || activePlan?.developer_plan) ? [{
      title: "Pricing",
      content: (
        <Pricing
          limit={limit}
          pricingHeading={pricingHeading}
          setActiveTab={selectTab}
        />
      ),
    }] : []),
  ];
  if (checkIfGhlUser) {
    sidebarMenus = sidebarMenus
      .filter((item) => item.title !== "Team")
      .filter((menu) => menu.title !== "Profile");
  }

  const filteredByGhlUser = sidebarMenus?.filter((menu) => {
    if (userActiveLocation?.email === userInfo?.email) return menu;
    return menu.title !== 'Wallet'
  });

  // Resolve the active tab from the URL hash (deep-link / shareable), else legacy
  // route-state, else the first available tab. Each configure page gets its own
  // URL (#slug) and is back-button friendly.
  useEffect(() => {
    if (!filteredByGhlUser.length) return;
    const exists = (t) => filteredByGhlUser.some((m) => m.title === t);
    const fromHash = hashToTab(location.hash);
    if (fromHash && exists(fromHash)) {
      if (fromHash !== activeTab) setActiveTab(fromHash);
      return;
    }
    if (location.state?.tab && exists(location.state.tab)) {
      setPricingHeading(location.state?.text || "");
      !location.state?.text && setLimit(true);
      navigate(`/app/settings${tabToHash(location.state.tab)}`, { replace: true });
      return;
    }
    if (!activeTab) setActiveTab(filteredByGhlUser[0].title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.hash, location.state, filteredByGhlUser]);

  // Tabs whose content is a full-width grid expand to the screen (match Lovable,
  // where the Tools grid is full-bleed). Other form-style tabs keep a readable,
  // left-anchored cap (the same 72rem the page used to impose globally).
  const WIDE_TABS = ["Integrations", "Knowledge Base", "Data Interpreter"];

  // Render the content based on the active tab
  const renderContent = () => {
    const selectedMenu = filteredByGhlUser.find(
      (menu) => menu.title === activeTab
    );
    if (!selectedMenu) return null;
    const widthClass = WIDE_TABS.includes(activeTab) ? "w-full" : "max-w-6xl";
    return <div className={widthClass}>{selectedMenu.content}</div>;
  };

  // (Tab resolution from URL hash / route-state is handled by the resolver effect above.)

  return (
    <div>
      <Helmet>
        <title>
          {agencyData?.Customization?.setting_m_title
            ? agencyData?.Customization?.setting_m_title
            : "Settings"}
        </title>
        <meta
          name="description"
          content={`${agencyData?.Customization?.setting_m_description}`}
        />
      </Helmet>
      <div className="settings-container relative h-full w-full px-4 sm:px-6 lg:px-8">
        {/* Main Content (full-width; section nav now lives in the app-shell Configure popover) */}
        <div className="main-content w-full">
          {/* Render the content based on the active tab */}
          {renderContent()}
        </div>
      </div>
    </div>
  );
}

export default Settings;
